import React from "react";
import "./Navbar.css";
import { Nav } from "react-bootstrap";

function Navbar() {
  return (
    <Nav className="navbar">
      <Nav.Link href="/" className="navbar-item">Home</Nav.Link>
      <Nav.Link href="/travel" className="navbar-item">Reisen</Nav.Link>
      <Nav.Link href="/mountainguide" className="navbar-item">Bergführer</Nav.Link>
      <Nav.Link href="/avalanches" className="navbar-item">Schnee</Nav.Link>
      <Nav.Link href="/about" className="navbar-item">Über uns</Nav.Link>
      <Nav.Link href="/contact" className="navbar-item">Kontakt</Nav.Link>
    </Nav>
  );
}

export default Navbar;
